module.exports = __webpack_public_path__ + "static/media/AccessBankPLCLogo.73f39443.svg";